import { useCallback } from 'react';
import { useRouter } from '../router';
import { updateQueryParams } from './updateQueryParams';
import { QueryParamsDictionary, UpdaterOptions } from './model';
import { getQueryParams } from './getQueryParams';

export type UpdateQueryParams<T extends QueryParamsDictionary = QueryParamsDictionary> = (
  updater: Partial<T>,
  options?: UpdaterOptions,
) => void;

export const useUpdateQueryParams = <T extends QueryParamsDictionary = QueryParamsDictionary>(
  updaterOptions?: UpdaterOptions,
): UpdateQueryParams<T> => {
  const router = useRouter();
  return useCallback(
    (update, options) => updateQueryParams(router, getQueryParams(router), update, { ...updaterOptions, ...options }),
    [router, updaterOptions],
  );
};
